// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2b7a37c5","178":"d6bf78c0","359":"537b2fff","477":"93146774","481":"d3a28150","538":"9b37b949","732":"3ff4c2a4","762":"a0aa67fc","770":"7e82bb99","807":"d08d436b","954":"e61afa1d","992":"46482bfa"}[chunkId] + ".chunk.js";
};